
import { atom } from "jotai";
import { ptpFilterGroups } from "./predicate";
import { PTPFilterAtom } from "./type";

const ptpFilters: PTPFilterAtom = {
  filterGroup: ptpFilterGroups,
  filterValues: {
    view: "ALL",
  },
  activeFilterKeys: [],
  sorting: {
    sort_col: "DEFAULT",
    order: 'DESC',
  },
};

export const ptpFiltersAtom = atom(ptpFilters);
